module.exports = __webpack_public_path__ + "static/media/blue-sky-logo@2x.bc46e5c4.png";